module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n7r2n5n-66869692ce23e9bc6cb2f320537e6c90.svg";